import BaseModelAPI from '../BaseModelAPI';

export default class PartMappingSubcontract extends BaseModelAPI {
	static entity = '';
	static entityName = 'partmappingsubcontract';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.partId = '';
			this.part = {};
			this.remarks = '';
			this.partSubcontId = '';
			this.partSubcont = {};
			this.vendorSubcontractId = '';
			this.vendorSubcontract = {};
			this.name = '';
			this.officeAddress = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}